<template>
    <section class="interview-title light purple">
        <circles-layout ref="circle"></circles-layout>
        <div class="css-grid panel-left">
            <div class="bg" style="background-image: url(/static/img/pages/interview-fredcarl.jpg)"></div>

            <div class="content-wrapper">
                <div class="content light purple">
                    <h3>Interview Fred&nbsp;van&nbsp;der&nbsp;Westerlaken en Carl&nbsp;Govers</h3>
                    <h2>Samen verder bouwen aan het beste onderwijs van Nederland</h2>
                    <button @click="openInterview">Lees het interview</button>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .bg{
        background-position:34% 50% !important;

        @media screen and ( min-width:720px ){
            background-position:28% 50% !important;
        }
    }
</style>

<script>
    import Circles from '@/app/components/circles';
    import InterviewFredCarl from '@/app/pages/sub/InterviewFredCarl';

    export default {
        name: 'BereiktInterview',
        meta: {
            title: 'BereiktInterview',
            color: '#a5147e'
        },

        components: {
            'circles-layout': Circles
        },

        methods: {
            openInterview()
            {
                this.$emit( 'openOverlay', InterviewFredCarl );
            }
        }
    };
</script>
